import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";

import { INVENTORY_ADJUSTMENT_STATUSES_CONFIG_MAP } from "consts";

import styles from "./InventoryAdjustmentStatusPlate.module.scss";
import { InventoryAdjustmentStatusCode } from "../../types/inventoryAdjustments";

interface Props {
  statusCode: InventoryAdjustmentStatusCode;
  className?: string;
}

export const InventoryAdjustmentStatusPlate = (props: Props) => {
  const { t } = useTranslation();
  const { statusCode, className } = props;
  const variant =
    statusCode && INVENTORY_ADJUSTMENT_STATUSES_CONFIG_MAP[statusCode];

  return statusCode && variant ? (
    <div className={classnames(styles.status, className)}>
      <InfoPlate variant={variant}>
        {t(`inventoryAdjustment.statuses.${statusCode}`)}
      </InfoPlate>
    </div>
  ) : (
    <div />
  );
};

export default InventoryAdjustmentStatusPlate;
